import { useMemo, useState } from "react";
import SearchLineIcon from "remixicon-react/SearchLineIcon";

const TagStatusPill = (props: { value: any }) => {
  const isActive = String(props.value || "").toLowerCase() === "active";
  return (
    <span className={`inline-block whitespace-nowrap px-1.5 py-0.5 rounded text-[10px] font-medium border ${isActive ? "bg-green-100 text-green-800 border-green-200" : "bg-red-100 text-red-800 border-red-200"}`}>
      {isActive ? "Active" : "Inactive"}
    </span>
  );
};

const LeftSideContainer = (props: any) => {
  const { getTagId, productTags, selectedTagId } = props;

  const [search, setSearch] = useState("");

  // The tag list arrives in full, so narrowing it is a local concern — no
  // round trip needed.
  const visibleTags = useMemo(() => {
    const query = search.trim().toLowerCase();
    if (!query) return productTags || [];
    return (productTags || []).filter((item: any) =>
      (item.name || "").toLowerCase().includes(query)
    );
  }, [productTags, search]);

  return (
    <div className="w-[30%] bg-white shadow-[0_1px_4px_rgba(0,0,0,.2)] rounded self-start">
      <div className="bg-[#f6f8f8] p-4 border-b border-b-[#efeff4]">
        <p className="text-base text-[#43425D]">
          Product Tag Names ({productTags?.length || 0})
        </p>
      </div>
      <div className="py-4 px-2.5">
        <div className="relative w-full px-2">
          <SearchLineIcon size={14} className="absolute left-4 top-1/2 -translate-y-1/2 text-[#858585]" />
          <input
            type="search"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Search tags"
            className="w-full h-9 rounded border border-[#EAEAEA] text-[#555] outline-none focus:border-blue-400 pl-8 pr-2.5 text-sm font-light"
          />
        </div>
        <ul className="mt-4 mx-2 border border-[#EAEAEA] rounded max-h-[420px] overflow-y-auto">
          {visibleTags.length === 0 ? (
            <li className="px-3 py-6 text-xs text-gray-500 text-center">
              {search ? "No tags match your search." : "No tags found."}
            </li>
          ) : (
            visibleTags.map((item: any) => (
              <li key={item.tagId} className="border-b border-[#EAEAEA] last:border-b-0">
                <button
                  type="button"
                  onClick={() => getTagId(item.tagId)}
                  className={`w-full flex items-center gap-2.5 text-left px-3 py-2.5 text-xs transition-colors ${
                    selectedTagId === item.tagId
                      ? "bg-[#CEE1FD] text-[#1d4ed8] font-medium"
                      : "text-[#454545] hover:bg-[#F8FAFF]"
                  }`}
                >
                  {/* Priority, image and status are only rendered when the
                      listing actually carries them, so a name-only payload
                      still renders a clean row. Priority can legitimately be 0,
                      so it checks for a value rather than truthiness. */}
                  {item.priority !== undefined && item.priority !== null && item.priority !== "" && (
                    <span
                      title={`Priority ${item.priority}`}
                      className="inline-block whitespace-nowrap px-1.5 py-0.5 rounded text-[10px] font-medium border bg-gray-100 text-gray-700 border-gray-200 flex-shrink-0"
                    >
                      P{item.priority}
                    </span>
                  )}
                  {item.imageUrl && (
                    <img
                      src={item.imageUrl}
                      alt=""
                      className="w-10 h-6 object-contain flex-shrink-0"
                    />
                  )}
                  <span className="flex-1 min-w-0 truncate" title={item.name}>
                    {item.name}
                  </span>
                  {item.status && <TagStatusPill value={item.status} />}
                </button>
              </li>
            ))
          )}
        </ul>
      </div>
    </div>
  );
};
export default LeftSideContainer;
